<script>
// @ts-check

export default {
  name: 'BasePaginationLinks',
  props: {
    // meta.links
    links: {
      type: Array,
      required: true
    },
    isLoading: {
      type: Boolean
    }
  },
  emits: ['updatePage'],
  computed: {
    prevPage() {
      return this.links[0]
    },
    nextPage() {
      return this.links[this.links.length - 1]
    },
    pageItems() {
      return this.links.filter(
        /**
         * @param {object} item
         * @param {number} index
         */
        (item, index) => index > 0 && index !== this.links.length - 1
      )
    }
  },
  methods: {
    /**
     * @param {?string} url
     */
    onClickPaginationButton(url) {
      if (!url || url.indexOf('page=') < 0) return

      const query = url.split('?')[1]
      const urlParams = new URLSearchParams(query)
      const page = urlParams.get('page')

      if (page) {
        this.$emit('updatePage', parseInt(page, 10))
      }
    }
  }
}
</script>

<template>
  <div
    class="flex items-center justify-center text-center text-sm leading-none select-none"
  >
    <button
      type="button"
      :disabled="isLoading || !prevPage.url"
      :aria-label="$t('general.previous')"
      class="mr-1 inline-flex h-6 items-center justify-center rounded-md px-2"
      :class="{
        'text-secondary-300': !prevPage.url
      }"
      @click="onClickPaginationButton(prevPage.url)"
    >
      <VIcon icon="$chevron-left" size="small" />
    </button>
    <div class="block">
      <button
        v-for="(item, i) in pageItems"
        :key="`${i}-pagination-item`"
        type="button"
        :disabled="isLoading || item.active"
        class="inline-block h-6 rounded-md px-2 align-middle"
        :class="{
          'bg-primary font-semibold text-white': item.active,
          'hover:underline': !item.active && item.url
        }"
        @click="onClickPaginationButton(item.url)"
      >
        {{ item.label }}
      </button>
    </div>
    <button
      type="button"
      :disabled="isLoading || !nextPage.url"
      :aria-label="$t('general.next')"
      class="ml-1 inline-flex h-6 items-center justify-center rounded-md px-2"
      :class="{
        'text-secondary-300': !nextPage.url
      }"
      @click="onClickPaginationButton(nextPage.url)"
    >
      <VIcon icon="$chevron-right" size="small" />
    </button>
  </div>
</template>
